import { ArchiveIcon, NoteOutlineIcon } from '@carboncopyco/icons';
import {
  ColorHex,
  ConfirmAlert,
  Loading,
  TextBase,
  TextButton,
} from '@carboncopyco/ui';

export interface ArchiveModalProps {
  onConfirm: () => void;
  onClose: () => void;
  show: boolean;
  totalActiveShares?: number;
  isLoading?: boolean;
}
export const ArchiveFolderModal = ({
  onConfirm,
  onClose,
  show,
  totalActiveShares,
  isLoading,
}: ArchiveModalProps) => {
  return (
    <ConfirmAlert
      onConfirm={onConfirm}
      danger={!!totalActiveShares}
      title="Archive folder"
      onClose={onClose}
      show={show}
      yesLabel={isLoading ? ' ' : 'Archive'}
      noLabel="Cancel"
      containerClass="w-ds-500"
      yesIcon={
        isLoading ? <Loading color="text-ds-accent3-100" /> : <ArchiveIcon />
      }
    >
      <div className="flex flex-col gap-2 mb-5">
        <TextBase
          label="Assets in this folder will no longer be accessible unless it’s restored."
          color="text-ds-natural-600"
        />
        {!!totalActiveShares && (
          <div className="flex items-center gap-1">
            <NoteOutlineIcon
              size={18}
              color={ColorHex.danger400}
            />
            <TextButton
              label="Note:"
              color="text-ds-natural-600"
            />
            <TextBase
              label={`${totalActiveShares} shared links will be deactivated.`}
              color="text-ds-natural-600"
            />
          </div>
        )}
      </div>
    </ConfirmAlert>
  );
};
